var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("hr"),
      _vm._v(" "),
      _c("p", { staticClass: "rb-login-overlay__title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.translation("private_sale.forgotPasswordTitle")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("rb-loading", { attrs: { loading: _vm.submitted } }),
      _vm._v(" "),
      !_vm.submitted
        ? [
            !_vm.success
              ? _c("div", { staticClass: "pdp-forgot-password" }, [
                  _c("p", { staticClass: "rb-login-overlay__subtitle" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("private_sale.forgotPasswordSubtitle")
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.error && _vm.errorMessage
                    ? _c("div", [
                        _c("p", { staticClass: "rb-login-overlay__error" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.errorMessage) +
                              "\n        "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      attrs: {
                        name: "forgotPasswordForm",
                        novalidate: "novalidate",
                      },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submit($event)
                        },
                      },
                    },
                    [
                      _c("rb-textfield", {
                        staticClass: "rb-login-overlay__email",
                        attrs: {
                          id: "emailAddress",
                          name: "emailAddress",
                          type: "email",
                          required: "true",
                          label: _vm.translation(
                            "private_sale.emailAddressLabel"
                          ),
                          error: _vm.translation(
                            "private_sale.emailAddressError"
                          ),
                          validation: _vm.$v.emailAddress,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "rb-login-overlay__action-group" },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "rb-btn rb-btn--black",
                              attrs: { type: "submit" },
                              on: { click: _vm.submit },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.translation("private_sale.submit")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.success
              ? _c("div", [
                  _c("p", { staticClass: "rb-login-overlay__subtitle" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation(
                            "private_sale.successForgotPasswordSubtitle"
                          )
                        )
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation(
                            "private_sale.successForgotPasswordFirstPart"
                          )
                        ) +
                        "\n        "
                    ),
                    _c("span", [_vm._v(_vm._s(_vm.emailAddress))]),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation(
                            "private_sale.pleaseCheckForgotPasswordSubtitle"
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }